import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MerlinMedia, SearchEntityResults } from '@src/suite/common/store/merlin/models/ai.seach.models';

export const MerlinSearchActions = createActionGroup({
    source: 'AI Search API',
    events: {
        'Generate Photo And Video Search Term': props<{ queryText: string }>(),
        'Photo And Video Search Term generated': props<{ searchTerm: string }>(),
        'Search Photo and Video': props<{ queryText: string }>(),
        'Search Photo and Video Success': props<{ photos: Array<MerlinMedia>; videos: Array<MerlinMedia>; searchTerm: string }>(),
        'Search Photo and Video Error': props<{ error: any }>(),
        'Search Entity': props<{ queryText: string }>(),
        'Search Entity Success': props<{ searchResults: SearchEntityResults }>(),
        'Search Entity Error': props<{ error: any }>(),
        'Empty Action': emptyProps(),
        'Clear Search Results': emptyProps(),
    },
});
